export default {
  shopNow: 'Comprar ahora',
  preSale: 'Preventa',
  header: {
    title: 'Tu monedero de hardware cripto seguro',
    subtitle: 'Almacena y gestiona tus criptoactivos de forma segura y sencilla',
  },
  introduce: {
    title: 'Te mereces un mejor monedero de hardware',
    subtitle: 'Seguro · Fiable · Sencillo',
    desc_1: 'Carcasa sólida que protege el monedero de daños',
    desc_2: 'Chips de grado militar que garantizan la seguridad',
    desc_3: 'Los dispositivos se identifican durante el uso',
    desc_4: 'Las claves se generan sin conexión y se almacenan localmente',
    desc_5: 'Firmas lo que ves',
    desc_6: 'Compatible con código PIN',
  },
  function: {
    title: 'Un monedero de hardware cripto todo en uno',
    subtitle: 'Un solo monedero para todas tus necesidades cripto',
    func_title_1: 'Proteger y almacenar',
    func_desc_1:
      'Genera tus claves y guárdalas en tu KeyPal con los chips más seguros del mundo. Más de 1000 cadenas compatibles. Nadie puede acceder salvo tú.',
    func_title_2: 'Comprar y hacer crecer',
    func_desc_2:
      'Compra Bitcoin, Ether y otras criptomonedas de forma simple, segura e inteligente. Hazlas crecer sin salir del monedero.',
    func_title_3: 'Intercambiar y cross-chain',
    func_desc_3:
      'Intercambia tus criptomonedas en segundos entre las cadenas compatibles; mueve fácilmente tus activos de una cadena a otra.',
    func_title_4: 'Desbloquear las posibilidades de las cripto',
    func_desc_4:
      'Accede de forma segura a todas las aplicaciones descentralizadas — DeFi, DApp, GameFi y NFT.',
  },
  software: {
    title: 'KeyPal & TokenPocket',
    connect: 'Métodos de conexión',
    crossPlatform: 'Compatibilidad multiplataforma',
    multiChains: 'Compatibilidad multi-chain',
    supportDesc:
      '(Compatible con todas las cadenas EVM, como BNB Smart Chain, Polygon, ETC, Arbitrum)',
    more: 'Más',
  },
  specification: {
    title: 'Especificaciones',
    card_1: 'Núcleo',
    option_label_1_1: 'Chips',
    option_desc_1_1: 'MCU + SE',
    option_label_1_2: 'Certificaciones y estándares',
    option_desc_1_2: 'DOE, CEC, BEC, CE, FCC y RoHS',

    card_2: 'Batería y conector',
    option_label_2_1: 'Batería',
    option_desc_2_1: '300 mAh',
    option_label_2_2: 'Conector',
    option_desc_2_2: 'USB Type-C',

    card_3: 'Tamaño y peso',
    option_label_3_1: 'Tamaño',
    option_desc_3_1: '91 x 55 x 9.0(mm)',
    option_label_3_2: 'Peso',
    option_desc_3_2: '63(g)',

    card_4: 'Pantalla',
    option_label_4_1: 'Pantalla',
    option_desc_4_1: '2 pulgadas',
    option_label_4_2: 'Visualización',
    option_desc_4_2: 'LCD, color',
    option_label_4_3: 'Resolución',
    option_desc_4_3: '320 x 480',

    card_5: 'Compatibilidad',
    option_desc_5_1: 'iOS, Android, macOS, Windows, Linux',

    card_6: 'Métodos de conexión',
    option_desc_6_1: 'Bluetooth y USB Type-C',

    card_7: 'Materiales',
    option_desc_7_1: 'Aleación de aluminio',

    card_8: 'Colores',
    option_desc_8_1: 'Negro, Plata, Dorado',

    btnTitle: 'Listo para usar el monedero KeyPal',
    btnSubTitle: 'Tu monedero de hardware cripto seguro',
  },
}
